import { init as dt } from "@rematch/core";
import { invert as pt, merge as ht } from "lodash";
import vt from "react";
import { useDispatch as tt, ReactReduxContext as bt, useSelector as St } from "react-redux";
import { ClientDevice as b } from "@ps/platform-message-framework/common/ClientDevice";
import { OSId as E } from "@ps/platform-message-framework/common/OSId";
import Et from "jwt-decode";
import { __values as H, __spreadArray as A, __read as D, __extends as U } from "tslib";
var R = "NOT_FOUND";
function gt(t) {
  var r;
  return {
    get: function(n) {
      return r && t(r.key, n) ? r.value : R;
    },
    put: function(n, i) {
      r = {
        key: n,
        value: i
      };
    },
    getEntries: function() {
      return r ? [r] : [];
    },
    clear: function() {
      r = void 0;
    }
  };
}
function mt(t, r) {
  var e = [];
  function n(a) {
    var c = e.findIndex(function(f) {
      return r(a, f.key);
    });
    if (c > -1) {
      var u = e[c];
      return c > 0 && (e.splice(c, 1), e.unshift(u)), u.value;
    }
    return R;
  }
  function i(a, c) {
    n(a) === R && (e.unshift({
      key: a,
      value: c
    }), e.length > t && e.pop());
  }
  function o() {
    return e;
  }
  function s() {
    e = [];
  }
  return {
    get: n,
    put: i,
    getEntries: o,
    clear: s
  };
}
var yt = function(r, e) {
  return r === e;
};
function Ot(t) {
  return function(e, n) {
    if (e === null || n === null || e.length !== n.length)
      return !1;
    for (var i = e.length, o = 0; o < i; o++)
      if (!t(e[o], n[o]))
        return !1;
    return !0;
  };
}
function _t(t, r) {
  var e = typeof r == "object" ? r : {
    equalityCheck: r
  }, n = e.equalityCheck, i = n === void 0 ? yt : n, o = e.maxSize, s = o === void 0 ? 1 : o, a = e.resultEqualityCheck, c = Ot(i), u = s === 1 ? gt(c) : mt(s, c);
  function f() {
    var l = u.get(arguments);
    if (l === R) {
      if (l = t.apply(null, arguments), a) {
        var d = u.getEntries(), v = d.find(function(m) {
          return a(m.value, l);
        });
        v && (l = v.value);
      }
      u.put(arguments, l);
    }
    return l;
  }
  return f.clearCache = function() {
    return u.clear();
  }, f;
}
function wt(t) {
  var r = Array.isArray(t[0]) ? t[0] : t;
  if (!r.every(function(n) {
    return typeof n == "function";
  })) {
    var e = r.map(function(n) {
      return typeof n == "function" ? "function " + (n.name || "unnamed") + "()" : typeof n;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + e + "]");
  }
  return r;
}
function It(t) {
  for (var r = arguments.length, e = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    e[n - 1] = arguments[n];
  var i = function() {
    for (var s = arguments.length, a = new Array(s), c = 0; c < s; c++)
      a[c] = arguments[c];
    var u = 0, f, l = {
      memoizeOptions: void 0
    }, d = a.pop();
    if (typeof d == "object" && (l = d, d = a.pop()), typeof d != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof d + "]");
    var v = l, m = v.memoizeOptions, h = m === void 0 ? e : m, ft = Array.isArray(h) ? h : [h], P = wt(a), Y = t.apply(void 0, [function() {
      return u++, d.apply(null, arguments);
    }].concat(ft)), z = t(function() {
      for (var Z = [], lt = P.length, j = 0; j < lt; j++)
        Z.push(P[j].apply(null, arguments));
      return f = Y.apply(null, Z), f;
    });
    return Object.assign(z, {
      resultFunc: d,
      memoizedResultFunc: Y,
      dependencies: P,
      lastResult: function() {
        return f;
      },
      recomputations: function() {
        return u;
      },
      resetRecomputations: function() {
        return u = 0;
      }
    }), z;
  };
  return i;
}
var et = /* @__PURE__ */ It(_t), Nt = function(r, e) {
  if (e === void 0 && (e = et), typeof r != "object")
    throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof r));
  var n = Object.keys(r), i = e(
    // @ts-ignore
    n.map(function(o) {
      return r[o];
    }),
    function() {
      for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++)
        s[a] = arguments[a];
      return s.reduce(function(c, u, f) {
        return c[n[f]] = u, c;
      }, {});
    }
  );
  return i;
}, At = function() {
  function r(e, n) {
    n === void 0 && (n = Nt);
    var i = function(s, a) {
      return i = n(e(r)), i(s, a);
    };
    return function(o, s) {
      return i(o, s);
    };
  }
  return r;
}, Dt = function() {
  var r = !1, e = /* @__PURE__ */ new Set();
  return {
    add: function(i) {
      r ? i.forEach(function(o) {
        return o();
      }) : i.forEach(function(o) {
        return e.add(o);
      });
    },
    finish: function(i) {
      e.delete(i);
    },
    startBuilding: function() {
      r = !0, e.forEach(function(i) {
        return i();
      });
    }
  };
}, Rt = function(r) {
  if (process.env.NODE_ENV !== "production") {
    if (r.sliceState && typeof r.sliceState != "function")
      throw new Error("select plugin config sliceState must be a function");
    if (r.selectorCreator && typeof r.selectorCreator != "function")
      throw new Error("select plugin config selectorCreator must be a function");
  }
}, Tt = function(r, e, n) {
  if (process.env.NODE_ENV !== "production" && typeof r?.[e] != "function")
    throw new Error("Selector (" + n.name + "/" + e + ") must be a function");
}, Ut = function(r) {
  r === void 0 && (r = {}), Rt(r);
  var e = r.sliceState || function(c, u) {
    return c[u.name || ""];
  }, n = r.selectorCreator || et, i = function(u) {
    return function(f) {
      return typeof f == "function" ? n(function(l) {
        return e(l, u);
      }, f) : e(f, u);
    };
  }, o = function(u) {
    return function(f) {
      var l = this;
      return n(function(d) {
        return d;
      }, function(d) {
        return u.call(l, f, d);
      });
    };
  }, s = Dt(), a = At();
  return {
    exposed: {
      select: a,
      sliceState: e,
      selectorCreator: n
    },
    onModel: function(u) {
      a[u.name] = {};
      var f = typeof u.selectors == "function" ? u.selectors(i(u), n, o) : u.selectors;
      s.add(Object.keys(f || {}).map(function(l) {
        Tt(f, l, u);
        var d = function v() {
          return s.finish(v), delete a[u.name][l], a[u.name][l] = f[l].call(a[u.name], a), a[u.name][l];
        };
        return Object.defineProperty(a[u.name], l, {
          configurable: !0,
          get: function() {
            return d();
          }
        }), d;
      }));
    },
    onStoreCreated: function(u) {
      s.startBuilding(), u.select = a;
    }
  };
}, g = /* @__PURE__ */ ((t) => (t[t.Windows = 1] = "Windows", t[t.Macintosh = 2] = "Macintosh", t[t.iOS = 3] = "iOS", t[t.Android = 4] = "Android", t[t.Web = 5] = "Web", t[t.MobileWeb = 8] = "MobileWeb", t))(g || {});
const Mt = {
  update: (t, r) => ({ ...t, ...r })
}, Pt = (t, r) => ({
  get() {
    return t;
  },
  getId() {
    return t(({ device: e }) => e);
  },
  getName() {
    return t(({ device: e }) => b[e]);
  },
  isMobile() {
    return t(({ device: e }) => [b.PHONE, b.TABLET].includes(e));
  },
  isPhone() {
    return t(({ device: e }) => e === b.PHONE);
  },
  isAndroid() {
    return t(({ os: e }) => e === E.ANDRO_ID);
  },
  getOS() {
    return t(({ os: e }) => e);
  },
  getOSName() {
    return t((e) => pt(E)[e.os]);
  },
  isDesktopEmbedded() {
    return t(
      ({ embedded: e, device: n }) => [b.DESKTOP, b.OTHER].includes(n) && e
    );
  },
  isMobileEmbedded() {
    return t(
      ({ embedded: e, device: n }) => [b.PHONE, b.TABLET].includes(n) && e
    );
  },
  isEmbedded() {
    return t(({ embedded: e }) => e);
  },
  getPlatform() {
    return r(
      t,
      (e) => [b.PHONE, b.TABLET].includes(e.device.device),
      (e, n) => {
        switch (!0) {
          case (e.embedded && e.os === E.WINDOWS):
            return g.Windows;
          case (e.embedded && e.os === E.MAC):
            return g.Macintosh;
          case (e.embedded && e.os === E.ANDRO_ID):
            return g.Android;
          case (e.embedded && e.os === E.I_OS):
            return g.iOS;
          case n:
            return g.MobileWeb;
          default:
            return g.Web;
        }
      }
    );
  }
}), jt = {
  state: { device: b.UNKNOWN, os: E.UNKNOWN, embedded: !1 },
  reducers: Mt,
  selectors: Pt
}, Bt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var rt = Kt, $ = Ft, xt = Object.prototype.toString, _ = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function Kt(t, r) {
  if (typeof t != "string")
    throw new TypeError("argument str must be a string");
  for (var e = {}, n = r || {}, i = n.decode || Ht, o = 0; o < t.length; ) {
    var s = t.indexOf("=", o);
    if (s === -1)
      break;
    var a = t.indexOf(";", o);
    if (a === -1)
      a = t.length;
    else if (a < s) {
      o = t.lastIndexOf(";", s - 1) + 1;
      continue;
    }
    var c = t.slice(o, s).trim();
    if (e[c] === void 0) {
      var u = t.slice(s + 1, a).trim();
      u.charCodeAt(0) === 34 && (u = u.slice(1, -1)), e[c] = Wt(u, i);
    }
    o = a + 1;
  }
  return e;
}
function Ft(t, r, e) {
  var n = e || {}, i = n.encode || Ct;
  if (typeof i != "function")
    throw new TypeError("option encode is invalid");
  if (!_.test(t))
    throw new TypeError("argument name is invalid");
  var o = i(r);
  if (o && !_.test(o))
    throw new TypeError("argument val is invalid");
  var s = t + "=" + o;
  if (n.maxAge != null) {
    var a = n.maxAge - 0;
    if (isNaN(a) || !isFinite(a))
      throw new TypeError("option maxAge is invalid");
    s += "; Max-Age=" + Math.floor(a);
  }
  if (n.domain) {
    if (!_.test(n.domain))
      throw new TypeError("option domain is invalid");
    s += "; Domain=" + n.domain;
  }
  if (n.path) {
    if (!_.test(n.path))
      throw new TypeError("option path is invalid");
    s += "; Path=" + n.path;
  }
  if (n.expires) {
    var c = n.expires;
    if (!Gt(c) || isNaN(c.valueOf()))
      throw new TypeError("option expires is invalid");
    s += "; Expires=" + c.toUTCString();
  }
  if (n.httpOnly && (s += "; HttpOnly"), n.secure && (s += "; Secure"), n.priority) {
    var u = typeof n.priority == "string" ? n.priority.toLowerCase() : n.priority;
    switch (u) {
      case "low":
        s += "; Priority=Low";
        break;
      case "medium":
        s += "; Priority=Medium";
        break;
      case "high":
        s += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (n.sameSite) {
    var f = typeof n.sameSite == "string" ? n.sameSite.toLowerCase() : n.sameSite;
    switch (f) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return s;
}
function Ht(t) {
  return t.indexOf("%") !== -1 ? decodeURIComponent(t) : t;
}
function Ct(t) {
  return encodeURIComponent(t);
}
function Gt(t) {
  return xt.call(t) === "[object Date]" || t instanceof Date;
}
function Wt(t, r) {
  try {
    return r(t);
  } catch {
    return t;
  }
}
function kt() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function Vt(t) {
  return typeof t == "string" ? rt(t) : typeof t == "object" && t !== null ? t : {};
}
function B(t, r = {}) {
  const e = Yt(t);
  if (!r.doNotParse)
    try {
      return JSON.parse(e);
    } catch {
    }
  return t;
}
function Yt(t) {
  return t && t[0] === "j" && t[1] === ":" ? t.substr(2) : t;
}
class zt {
  constructor(r, e = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const i = this.cookies;
      this.cookies = rt(document.cookie), this._checkChanges(i);
    };
    const n = typeof document > "u" ? "" : document.cookie;
    this.cookies = Vt(r || n), this.defaultSetOptions = e, this.HAS_DOCUMENT_COOKIE = kt();
  }
  _emitChange(r) {
    for (let e = 0; e < this.changeListeners.length; ++e)
      this.changeListeners[e](r);
  }
  _checkChanges(r) {
    new Set(Object.keys(r).concat(Object.keys(this.cookies))).forEach((n) => {
      r[n] !== this.cookies[n] && this._emitChange({
        name: n,
        value: B(r[n])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(r, e = {}) {
    return e.doNotUpdate || this.update(), B(this.cookies[r], e);
  }
  getAll(r = {}) {
    r.doNotUpdate || this.update();
    const e = {};
    for (let n in this.cookies)
      e[n] = B(this.cookies[n], r);
    return e;
  }
  set(r, e, n) {
    n ? n = Object.assign(Object.assign({}, this.defaultSetOptions), n) : n = this.defaultSetOptions;
    const i = typeof e == "string" ? e : JSON.stringify(e);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [r]: i }), this.HAS_DOCUMENT_COOKIE && (document.cookie = $(r, i, n)), this._emitChange({ name: r, value: e, options: n });
  }
  remove(r, e) {
    const n = e = Object.assign(Object.assign({}, e), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[r], this.HAS_DOCUMENT_COOKIE && (document.cookie = $(r, "", n)), this._emitChange({ name: r, value: void 0, options: e });
  }
  addChangeListener(r) {
    this.changeListeners.push(r), this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(r) {
    const e = this.changeListeners.indexOf(r);
    e >= 0 && this.changeListeners.splice(e, 1), this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
var w, Zt = new Uint8Array(16);
function $t() {
  if (!w && (w = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !w))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return w(Zt);
}
const Lt = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Jt(t) {
  return typeof t == "string" && Lt.test(t);
}
var p = [];
for (var x = 0; x < 256; ++x)
  p.push((x + 256).toString(16).substr(1));
function Xt(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = (p[t[r + 0]] + p[t[r + 1]] + p[t[r + 2]] + p[t[r + 3]] + "-" + p[t[r + 4]] + p[t[r + 5]] + "-" + p[t[r + 6]] + p[t[r + 7]] + "-" + p[t[r + 8]] + p[t[r + 9]] + "-" + p[t[r + 10]] + p[t[r + 11]] + p[t[r + 12]] + p[t[r + 13]] + p[t[r + 14]] + p[t[r + 15]]).toLowerCase();
  if (!Jt(e))
    throw TypeError("Stringified UUID is invalid");
  return e;
}
function qt(t, r, e) {
  t = t || {};
  var n = t.random || (t.rng || $t)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, r) {
    e = e || 0;
    for (var i = 0; i < 16; ++i)
      r[e + i] = n[i];
    return r;
  }
  return Xt(n);
}
var T = /* @__PURE__ */ ((t) => (t.ADD_TO_HOME_SCREEN = "A2HS", t.AFFILIATE_INFO = "ptiram", t.AFFILIATE_REF = "pstrk.afref", t.BIAB_CUSTOMER = "BIAB_CUSTOMER", t.BIAB_LANGUAGE = "BIAB_LANGUAGE", t.BIAB_TIMEZONE = "BIAB_TZ", t.BRAND = "BRAND", t.CLIENT_TIME_ZONE = "CLIENT_TIME_ZONE", t.COOKIE_NOTIFICATION = "cookieDisclaimer", t.COUNTRY = "CTRY", t.CURRENCY = "CURR", t.DOWNLOAD_BANNER = "ADB", t.FACEBOOK_CLICK_ID = "_fbc", t.FACEBOOK_BROWSER_ID = "_fbp", t.FIRST_LOGIN = "FIRST_LOGIN", t.INSTALL_ID = "XIID", t.LANGUAGE = "LANG", t.LICENSE = "LCNS", t.LIMITED_MODE = "LMTMOD", t.MAXYMISER_ID = "pstrk.testid", t.MY_NEWS_SEEN = "CRM_TARGETED_SEEN", t.NPS_INTERACTION = "NPS_INTERACTION", t.ODDS_FORMAT = "ODDS_FORMAT", t.ONE_TRUST_CONSENT = "OptanonConsent", t.PROMO = "promo", t.PROMO_IA = "promo_ia", t.REDIRECT_CONTEXT = "REDIRECT_CONTEXT", t.INSTITUTION_ID = "institution_id", t.SIGNAL_ID = "signalid", t.SIGNATURE = "SBSG", t.SITE = "SITE", t.SIZMEK_UID = "sizmek_uid", t.SOFT_REDIRECT_CANCELLED = "soft-redirect-cancelled", t.TOKEN = "SBTK", t.USER = "user", t.WEB_ID = "WBID", t))(T || {}), Qt = /* @__PURE__ */ ((t) => (t.Login = "login", t.Registration = "registration", t.VerifySession = "verifySession", t))(Qt || {});
const C = new zt(), G = () => {
  const t = "server";
  let r = C.get(T.INSTALL_ID);
  return !r && Bt && (r = process.env.NODE_ENV === "test" ? "testInstallId" : qt().split("-").map((e) => parseInt(e, 36)).map((e) => e.toString()).join("").slice(0, 18).toUpperCase(), C.set(T.INSTALL_ID, r, {
    domain: window.location.hostname.split(".").slice(1).join("."),
    path: "/"
  })), r ? { installId: r, authSource: t } : { authSource: t };
}, te = {
  response: (t, { account: r, ...e }) => ({
    ...G(),
    ...e,
    authSource: "client"
  }),
  update: (t, r) => ({
    ...G(),
    ...t,
    ...r
  }),
  clear: ({ authSource: t, installId: r }) => ({ authSource: t, installId: r })
}, ee = (t, r) => ({
  get() {
    return t;
  },
  getJWTValues() {
    return r(t, ({ token: e }) => {
      try {
        return Et(e);
      } catch {
        return;
      }
    });
  },
  getLegacySession() {
    return r(
      t,
      (e) => y.session.getJWTValues(e),
      ({ token: e, signature: n, userWebId: i }, o) => o ? {
        token: o.token,
        signature: C.get(T.SIGNATURE),
        userWebId: o.webId
      } : { token: e, signature: n, userWebId: i }
    );
  },
  getWebId() {
    return r(
      (e) => y.session.getLegacySession(e),
      ({ userWebId: e }) => e
    );
  },
  hasClientSession() {
    return t(({ authSource: e }) => e === "client");
  },
  /**
   * Determines if the client has a validated session token.
   * Will always be false for SSR and for first client render
   */
  isClientAuthenticated() {
    return r(
      (e) => y.session.getLegacySession(e),
      ({ token: e }) => !!e
    );
  },
  /**
   * Determines if the user has a session token, which may not be validated.
   * May be true for SSR and first client render
   * Use "isClientAuthenticated" if you need to know the session has been validated.
   */
  isAuthenticated() {
    return r(
      t,
      (e) => y.session.isClientAuthenticated(e),
      ({ serverAuth: e }, n) => e || n
    );
  },
  isAuthenticationCheckComplete() {
    return r(
      t,
      (e) => y.session.isClientAuthenticated(e),
      ({ serverAuth: e }, n) => e === n
    );
  },
  isFirstAuthenticatedSession() {
    return t(
      ({ loginSource: e }) => e === "registration"
      /* Registration */
    );
  },
  isServerAuthenticated() {
    return t(({ serverAuth: e, authSource: n }) => !!e && n === "server");
  }
}), re = {
  state: G(),
  reducers: te,
  selectors: ee
}, ne = { device: jt, session: re };
function S(t) {
  return typeof t == "function";
}
function nt(t) {
  var r = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, e = t(r);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var K = nt(function(t) {
  return function(e) {
    t(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(n, i) {
      return i + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function W(t, r) {
  if (t) {
    var e = t.indexOf(r);
    0 <= e && t.splice(e, 1);
  }
}
var M = function() {
  function t(r) {
    this.initialTeardown = r, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var r, e, n, i, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = H(s), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (h) {
            r = { error: h };
          } finally {
            try {
              c && !c.done && (e = a.return) && e.call(a);
            } finally {
              if (r)
                throw r.error;
            }
          }
        else
          s.remove(this);
      var f = this.initialTeardown;
      if (S(f))
        try {
          f();
        } catch (h) {
          o = h instanceof K ? h.errors : [h];
        }
      var l = this._finalizers;
      if (l) {
        this._finalizers = null;
        try {
          for (var d = H(l), v = d.next(); !v.done; v = d.next()) {
            var m = v.value;
            try {
              L(m);
            } catch (h) {
              o = o ?? [], h instanceof K ? o = A(A([], D(o)), D(h.errors)) : o.push(h);
            }
          }
        } catch (h) {
          n = { error: h };
        } finally {
          try {
            v && !v.done && (i = d.return) && i.call(d);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
      if (o)
        throw new K(o);
    }
  }, t.prototype.add = function(r) {
    var e;
    if (r && r !== this)
      if (this.closed)
        L(r);
      else {
        if (r instanceof t) {
          if (r.closed || r._hasParent(this))
            return;
          r._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(r);
      }
  }, t.prototype._hasParent = function(r) {
    var e = this._parentage;
    return e === r || Array.isArray(e) && e.includes(r);
  }, t.prototype._addParent = function(r) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(r), e) : e ? [e, r] : r;
  }, t.prototype._removeParent = function(r) {
    var e = this._parentage;
    e === r ? this._parentage = null : Array.isArray(e) && W(e, r);
  }, t.prototype.remove = function(r) {
    var e = this._finalizers;
    e && W(e, r), r instanceof t && r._removeParent(this);
  }, t.EMPTY = function() {
    var r = new t();
    return r.closed = !0, r;
  }(), t;
}(), it = M.EMPTY;
function ot(t) {
  return t instanceof M || t && "closed" in t && S(t.remove) && S(t.add) && S(t.unsubscribe);
}
function L(t) {
  S(t) ? t() : t.unsubscribe();
}
var st = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, k = {
  setTimeout: function(t, r) {
    for (var e = [], n = 2; n < arguments.length; n++)
      e[n - 2] = arguments[n];
    var i = k.delegate;
    return i?.setTimeout ? i.setTimeout.apply(i, A([t, r], D(e))) : setTimeout.apply(void 0, A([t, r], D(e)));
  },
  clearTimeout: function(t) {
    var r = k.delegate;
    return (r?.clearTimeout || clearTimeout)(t);
  },
  delegate: void 0
};
function ie(t) {
  k.setTimeout(function() {
    throw t;
  });
}
function J() {
}
function N(t) {
  t();
}
var at = function(t) {
  U(r, t);
  function r(e) {
    var n = t.call(this) || this;
    return n.isStopped = !1, e ? (n.destination = e, ot(e) && e.add(n)) : n.destination = ue, n;
  }
  return r.create = function(e, n, i) {
    return new V(e, n, i);
  }, r.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, r.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, r.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, r.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, r.prototype._next = function(e) {
    this.destination.next(e);
  }, r.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, r.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, r;
}(M), oe = Function.prototype.bind;
function F(t, r) {
  return oe.call(t, r);
}
var se = function() {
  function t(r) {
    this.partialObserver = r;
  }
  return t.prototype.next = function(r) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(r);
      } catch (n) {
        I(n);
      }
  }, t.prototype.error = function(r) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(r);
      } catch (n) {
        I(n);
      }
    else
      I(r);
  }, t.prototype.complete = function() {
    var r = this.partialObserver;
    if (r.complete)
      try {
        r.complete();
      } catch (e) {
        I(e);
      }
  }, t;
}(), V = function(t) {
  U(r, t);
  function r(e, n, i) {
    var o = t.call(this) || this, s;
    if (S(e) || !e)
      s = {
        next: e ?? void 0,
        error: n ?? void 0,
        complete: i ?? void 0
      };
    else {
      var a;
      o && st.useDeprecatedNextContext ? (a = Object.create(e), a.unsubscribe = function() {
        return o.unsubscribe();
      }, s = {
        next: e.next && F(e.next, a),
        error: e.error && F(e.error, a),
        complete: e.complete && F(e.complete, a)
      }) : s = e;
    }
    return o.destination = new se(s), o;
  }
  return r;
}(at);
function I(t) {
  ie(t);
}
function ae(t) {
  throw t;
}
var ue = {
  closed: !0,
  next: J,
  error: ae,
  complete: J
}, ce = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function fe(t) {
  return t;
}
function le(t) {
  return t.length === 0 ? fe : t.length === 1 ? t[0] : function(e) {
    return t.reduce(function(n, i) {
      return i(n);
    }, e);
  };
}
var X = function() {
  function t(r) {
    r && (this._subscribe = r);
  }
  return t.prototype.lift = function(r) {
    var e = new t();
    return e.source = this, e.operator = r, e;
  }, t.prototype.subscribe = function(r, e, n) {
    var i = this, o = pe(r) ? r : new V(r, e, n);
    return N(function() {
      var s = i, a = s.operator, c = s.source;
      o.add(a ? a.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, t.prototype._trySubscribe = function(r) {
    try {
      return this._subscribe(r);
    } catch (e) {
      r.error(e);
    }
  }, t.prototype.forEach = function(r, e) {
    var n = this;
    return e = q(e), new e(function(i, o) {
      var s = new V({
        next: function(a) {
          try {
            r(a);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      n.subscribe(s);
    });
  }, t.prototype._subscribe = function(r) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(r);
  }, t.prototype[ce] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var r = [], e = 0; e < arguments.length; e++)
      r[e] = arguments[e];
    return le(r)(this);
  }, t.prototype.toPromise = function(r) {
    var e = this;
    return r = q(r), new r(function(n, i) {
      var o;
      e.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return i(s);
      }, function() {
        return n(o);
      });
    });
  }, t.create = function(r) {
    return new t(r);
  }, t;
}();
function q(t) {
  var r;
  return (r = t ?? st.Promise) !== null && r !== void 0 ? r : Promise;
}
function de(t) {
  return t && S(t.next) && S(t.error) && S(t.complete);
}
function pe(t) {
  return t && t instanceof at || de(t) && ot(t);
}
var he = nt(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), ut = function(t) {
  U(r, t);
  function r() {
    var e = t.call(this) || this;
    return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
  }
  return r.prototype.lift = function(e) {
    var n = new Q(this, this);
    return n.operator = e, n;
  }, r.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new he();
  }, r.prototype.next = function(e) {
    var n = this;
    N(function() {
      var i, o;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var s = H(n.currentObservers), a = s.next(); !a.done; a = s.next()) {
            var c = a.value;
            c.next(e);
          }
        } catch (u) {
          i = { error: u };
        } finally {
          try {
            a && !a.done && (o = s.return) && o.call(s);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, r.prototype.error = function(e) {
    var n = this;
    N(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = e;
        for (var i = n.observers; i.length; )
          i.shift().error(e);
      }
    });
  }, r.prototype.complete = function() {
    var e = this;
    N(function() {
      if (e._throwIfClosed(), !e.isStopped) {
        e.isStopped = !0;
        for (var n = e.observers; n.length; )
          n.shift().complete();
      }
    });
  }, r.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(r.prototype, "observed", {
    get: function() {
      var e;
      return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), r.prototype._trySubscribe = function(e) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, e);
  }, r.prototype._subscribe = function(e) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
  }, r.prototype._innerSubscribe = function(e) {
    var n = this, i = this, o = i.hasError, s = i.isStopped, a = i.observers;
    return o || s ? it : (this.currentObservers = null, a.push(e), new M(function() {
      n.currentObservers = null, W(a, e);
    }));
  }, r.prototype._checkFinalizedStatuses = function(e) {
    var n = this, i = n.hasError, o = n.thrownError, s = n.isStopped;
    i ? e.error(o) : s && e.complete();
  }, r.prototype.asObservable = function() {
    var e = new X();
    return e.source = this, e;
  }, r.create = function(e, n) {
    return new Q(e, n);
  }, r;
}(X), Q = function(t) {
  U(r, t);
  function r(e, n) {
    var i = t.call(this) || this;
    return i.destination = e, i.source = n, i;
  }
  return r.prototype.next = function(e) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || i === void 0 || i.call(n, e);
  }, r.prototype.error = function(e) {
    var n, i;
    (i = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || i === void 0 || i.call(n, e);
  }, r.prototype.complete = function() {
    var e, n;
    (n = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || n === void 0 || n.call(e);
  }, r.prototype._subscribe = function(e) {
    var n, i;
    return (i = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e)) !== null && i !== void 0 ? i : it;
  }, r;
}(ut);
const ve = () => {
  const t = new ut(), r = {};
  return {
    config: {
      redux: {
        middlewares: [
          (e) => (n) => (i) => {
            const o = n(i);
            return t.next({ ...i, state: e.getState() }), o;
          }
        ]
      }
    },
    onModel(e, n) {
      const { name: i, effects: o } = e, { dispatch: s } = n;
      if (o) {
        if (typeof o == "function")
          throw new Error(
            "Model effects must be plain objects, global dispatch is provided to each effect."
          );
        Object.entries(o).forEach(([a, c]) => {
          r[`${i}/${a}`] = (u, f) => c(u, { actions: t, dispatch: s, rootState: f, select: n.select });
        });
      }
    },
    onStoreCreated(e, n) {
      n.effects = r;
    }
  };
};
var be = /* @__PURE__ */ ((t) => (t.AustralianDollar = "AUD", t.BritishPound = "GBP", t.BulgarianLev = "BGN", t.CanadianDollar = "CAD", t.ChileanPeso = "CLP", t.DanishKrone = "DKK", t.Euro = "EUR", t.HungarianForint = "HUF", t.IndianRupee = "INR", t.JapaneseYen = "JPY", t.MexicanPeso = "MXN", t.NorwegianKrone = "NOK", t.PlayMoney = "PFF", t.PolishZloty = "PLN", t.RomanianLeu = "RON", t.RussianRuble = "RUB", t.SwedishKrona = "SEK", t.SwissFranc = "CHF", t.UkrainianHryvnia = "UAH", t.USDollar = "USD", t.BrazilianReal = "BRL", t.SlovakKoruna = "SKK", t.IcelandicKrona = "ISK", t.EstonianKroon = "EEK", t.CzechKoruna = "CZK", t.NewZealandDollar = "NZD", t.LithuanianLitas = "LTL", t.LatvianLats = "LVL", t.SouthAfricanRand = "ZAR", t.ArgentinePeso = "ARS", t.ColombianPeso = "COP", t.ChineseYuan = "CNY", t.PhilippinePeso = "PHP", t.CroatianKuna = "HRK", t.NewTaiwanDollar = "TWD", t.ThaiBaht = "THB", t.PeruvianSol = "PEN", t.UruguayanPeso = "UYU", t.BelarusianRuble = "BYR", t.MoldovanLeu = "MDL", t.KazakhstaniTenge = "KZT", t.ParaguayanGuarani = "PYG", t.SerbianDinar = "RSD", t.MongolianTugrik = "MNT", t))(be || {}), Se = /* @__PURE__ */ ((t) => (t[t.Initial = 1] = "Initial", t[t.Annual = 2] = "Annual", t))(Se || {}), Ee = /* @__PURE__ */ ((t) => (t[t.Decimal = 1] = "Decimal", t[t.Fractional = 2] = "Fractional", t[t.American = 3] = "American", t))(Ee || {}), ge = /* @__PURE__ */ ((t) => (t.UNDEFINED = "UNDEFINED", t.ACTIVE = "ACTIVE", t.PENDING_LONG_SESSION = "PENDING_LONG_SESSION", t))(ge || {}), me = /* @__PURE__ */ ((t) => (t[t.NotBanned = 0] = "NotBanned", t[t.Banned = 1] = "Banned", t[t.Unbanned = 2] = "Unbanned", t[t.RemainBanned = 4] = "RemainBanned", t))(me || {}), ye = /* @__PURE__ */ ((t) => (t[t.COM = 0] = "COM", t[t.IT = 8] = "IT", t[t.FR = 16] = "FR", t[t.EE = 32] = "EE", t[t.BE = 64] = "BE", t[t.ES = 128] = "ES", t[t.DK = 256] = "DK", t[t.EU = 512] = "EU", t[t.USNJ = 2048] = "USNJ", t[t.UK = 4096] = "UK", t[t.BG = 8192] = "BG", t[t.DESH = 16384] = "DESH", t[t.RO = 65536] = "RO", t[t.PT = 131072] = "PT", t[t.CZ = 262144] = "CZ", t[t.IN = 524288] = "IN", t[t.ASIA = 1048576] = "ASIA", t[t.RU = 2097152] = "RU", t[t.USPA = 4194304] = "USPA", t[t.SE = 8388608] = "SE", t[t.CH = 16777216] = "CH", t[t.USMI = 16777220] = "USMI", t[t.NL = 16777221] = "NL", t[t.CAON = 16777222] = "CAON", t[t.GR = 16777250] = "GR", t[t.USCO = 16777218] = "USCO", t[t.DE = 16777219] = "DE", t))(ye || {}), Oe = /* @__PURE__ */ ((t) => (t[t.None = 0] = "None", t[t.AuthenticationPeriod = 2] = "AuthenticationPeriod", t[t.Suspended = 3] = "Suspended", t))(Oe || {});
const _e = [Ut(), ve()], we = (t) => {
  const e = { models: Object.assign({}, ne, t.models), plugins: _e };
  return dt(ht(t, e));
}, ct = (t, r) => (...e) => {
  const n = vt.useContext(bt);
  for (const i in r.models)
    i in n.store.dispatch || n.store.addModel({ ...r.models[i], name: i });
  return t(...e);
}, { select: y } = we({ name: "core-store" }), Pe = (t) => ct(St, t), je = (t) => ct(tt, t), Be = tt;
export {
  me as BanPopupType,
  g as CasinoClientPlatform,
  T as Cookie,
  be as Currency,
  ye as License,
  Se as LifetimeLimitAckType,
  Qt as LoginSource,
  Ee as OddsFormat,
  ge as OperatorGuardPlayerStatus,
  Oe as TemporaryAccountType,
  we as createStore,
  je as makeUseDispatch,
  Pe as makeUseSelector,
  ne as models,
  y as select,
  Be as useDispatch
};
